import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'convertTo',
    standalone: false
})
export class ConvertToPipe implements PipeTransform {
  transform<T>(value: any, _type: (new (...args: any[]) => T) | T): T {
    return value as T;
  }
}
